<template>
  <div class="pageHeader pageHeader--hasDate">
      <div class="pageHeader__main">
          <h1 class="pageHeader__heading">
            {{ order.hospital_prefecture_id }} {{ order.hospital_workplace_type }} - {{ order.displayed_wanted_jobs }}
            <span>の求人詳細</span>
          </h1>
      </div>
      <time class="pageHeader__date">最新公開日：{{ order.displayed_updated_at }}</time>
  </div>
</template>
<script>
export default {
  name: 'PageHeader',
  props: ['order']
}
</script>
